import { isEmpty } from "./helpers";

export const convertTableToCell = (columns = [], rows = [], startRowNo, maxColNo) => {
  let cellList = [];
  const rowNo = startRowNo || 0;
  const endColNo = maxColNo || columns?.length;

  for (let colNo = 1; colNo <= endColNo; colNo++) {
    const column = columns[colNo - 1];
    if (!isEmpty(column)) {
      cellList.push({ rowNo, colNo, value: column.title, cellStyle: { bgColor: "99,172,238", color: "255,255,255", hAlign: "left" } });
      rows.forEach((row, rowIdx) =>
        cellList.push({ rowNo: rowNo + rowIdx + 1, colNo, value: row[column.dataKey], type: column.type, cellStyle: column.cellStyle })
      );
    } else {
      cellList.push({ rowNo, colNo, cellStyle: { bgColor: "99,172,238", color: "255,255,255", hAlign: "left" } });
      rows.forEach((_, rowIdx) => cellList.push({ rowNo: rowNo + rowIdx + 1, colNo }));
    }
  }

  return cellList.sort((a, b) => (a.rowNo === b.rowNo ? a.colNo - b.colNo : a.rowNo - b.rowNo));
};
